import { BaseDatePicker } from '../../../components/shared'
import React from 'react'
import { getMinDate, getMaxDate } from '../functions'
import { any, func } from 'prop-types'
export default function FormResumeDatePicker({ value, onChange, inputProps }) {
  return (
    <BaseDatePicker
      inputFormat="MM/YYYY"
      mask="__/____"
      openTo="month"
      views={['year', 'month']}
      minDate={getMinDate()}
      maxDate={getMaxDate()}
      label="Período"
      value={value}
      onChange={onChange}
      inputProps={inputProps}
    />
  )
}

FormResumeDatePicker.propTypes = {
  value: any,
  onChange: func,
  inputProps: any
}
